const MAP = {
  paid: { label: "Paid", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  partial: { label: "Partial", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  sent: { label: "Sent", cls: "bg-slate-100 text-slate-600 border-slate-200" },
  overdue: { label: "Overdue", cls: "bg-rose-50 text-rose-700 border-rose-200" },
  draft: { label: "Draft", cls: "bg-slate-100 text-slate-500 border-slate-200" },
  pending: { label: "Pending", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  accepted: { label: "Accepted", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  rejected: { label: "Rejected", cls: "bg-rose-50 text-rose-700 border-rose-200" },
  cancelled: { label: "Cancelled", cls: "bg-slate-200 text-slate-600 border-slate-300" },
  active: { label: "Active", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  paused: { label: "Paused", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  completed: { label: "Completed", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  sent_status: { label: "Sent", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  failed: { label: "Failed", cls: "bg-rose-50 text-rose-700 border-rose-200" },
  skipped: { label: "Skipped", cls: "bg-slate-100 text-slate-500 border-slate-200" },
};

export function StatusBadge({ status, testId }) {
  const s = MAP[status] || { label: status || "—", cls: "bg-slate-100 text-slate-600 border-slate-200" };
  return (
    <span
      data-testid={testId || "status-badge"}
      className={`inline-flex items-center border font-semibold px-2.5 py-0.5 rounded-full text-xs capitalize ${s.cls}`}
    >
      {s.label}
    </span>
  );
}
